import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';


class NewModalConfirm extends Component {

	constructor(props) {
	    super(props);
	    	this.state = {
		    modal: false
		};
		this.toggleModal = this.toggleModal.bind(this);
		this.actionModal = this.actionModal.bind(this);
	}
	static modals = [];
    static open = (id) => (e) => {
        e.preventDefault();

        let modal = NewModalConfirm.modals.find(x => x.props.id === id);
        modal && modal.setState({ modal: true });
    }

    static eventClose = (id) => (e) => {
        e.preventDefault();

        let modal = NewModalConfirm.modals.find(x => x.props.id === id);
        modal.setState({ modal: false });
    }

    static close = (id) => {
        let modal = NewModalConfirm.modals.find(x => x.props.id === id);
        modal.setState({ modal: false });
    }

    componentDidMount() {
        NewModalConfirm.modals.push(this);
    }

    componentWillUnmount() {
        NewModalConfirm.modals = NewModalConfirm.modals.filter(x => x.props.id !== this.props.id);
    }

    acceptButton() {
    	if(this.props.confirmFunc){
			this.props.confirmFunc();
			NewModalConfirm.close(this.props.id);
		}
		else
			NewModalConfirm.close(this.props.id);
    }

	toggleModal() {
	    this.setState({
	      modal: !this.state.modal,
	    });
	}

	actionModal (){
		if(this.props.confirmFunc){
			this.props.confirmFunc()
			this.toggleModal()
		}else{
			this.toggleModal()
		}
	}

	render () {
		return (
			<Modal id={this.props.id} isOpen = { this.state.modal } toggle = { this.toggleModal } className = { this.props.className } >
				<ModalBody>
					{ this.props.html }
				</ModalBody>
				<ModalFooter>
					{/* como no sueles usar el id en los modales, lo uso para diferenciar tus modales que tenias de los nuevos para la tabla */}
					<Button color="primary" style={this.props.bg_company ? this.props.bg_company : undefined} onClick={this.acceptButton.bind(this)} > {this.props.json_lang.common.accept} </Button>
					<Button color = "secondary" onClick = { NewModalConfirm.eventClose(this.props.id) } > {this.props.json_lang.common.cancel} </Button>
				</ModalFooter>
			</Modal>
		)
	}
}
const mapStateToProps = (state) => {
	return {
		errors: state.errors,
		admin: state.admin,
		json_lang: state.json_lang,
		bg_company:{ 
			background: state.company_styles_json.color_accent,
			borderColor: state.company_styles_json.color_accent,
		},
		btn_link:{ color: state.company_styles_json.color_accent},
	}
}


export default connect(mapStateToProps)(NewModalConfirm);


// WEBPACK FOOTER //
// ./src/views/Plugins/MainModals/NewModalConfirm.jsx